<tui-checkbox
  size="l"
  [disabled]="formControl.disabled"
  [ngModel]="value$ | async"
  (ngModelChange)="formControl.setValue($event); formControl.markAsDirty()"
></tui-checkbox>
